<template>
    <div class="main-content">
      <!-- Page Header Start -->
      <PageHeader>
        <PageHeaderTitleContent>
          <TitleTextContent
            :titleText="blogHeaderTitle"
            :subTitleText="'The Project Spectrum Cyber Advisory Team is one of the best – and the group regularly writes about key issues that affect every user in the cyber realm. Get key insights from experts on the latest developments affecting your work in cyberspace. Check this space regularly – we update it often!'"
          />
          <router-link 
            v-if="isRecentBlogs"
            :to="{
              name: 'cybercorner',
            }"
          >
            <v-btn
              rounded
              large
              dark
              class="mt-4"
              :color="'#424EC4'"
            >
              Back to Cyber Corner
            </v-btn>
          </router-link>
        </PageHeaderTitleContent>
      </PageHeader>
      <!-- Page Header End -->
      <section class="section p-0 mt-5 mb-5 section-content">
        <div class="container-fluid px-xs-1 px-md-5 px-lg-5 px-xl-5">
          <div class="w-100 d-flex justify-content-center section-title">
            <span>READ OUR BLOGS</span>
          </div>
  
          <!-- Blog Search Start -->
          <div v-if="totalRows > 0" class="mb-5">
            <SearchControlWidget
              :inputTextPlaceholder="'Enter blog title here'"
              :searchControlHeight="'100px'"
              :searchQueryInputHandler="updateSearchQuery"
            />
          </div>
          <!-- Blog Search End -->
  
          <!-- Blog list Items Start -->
          <div class="row m-0 mb-4">
            <div 
              class="col-12 col-md-6 col-lg-6 col-xl-6 p-2"
              v-for="item in displayedBlogItems"
              :key="item.id"
            >
              <BlogPreviewBadge 
                :key="item.id" 
                :id="item.id" 
                :image="item.mainImage"
                :imageDescription="item.photoDescription"
                :title="item.title"
                :caption="item.headLine"
                :date="item.date"
                :blogPage="String(currentPage)"
                :query="searchQuery"
                :isRecentBlogs="isRecentBlogs"
              />
            </div>
          </div>
          <!-- Blog list Items End -->
  
          <div v-if="(totalRows > 0) && (totalRows > perPage)" class="mb-5">
            <b-pagination
              class="ml-0"
              id="blog-pagination"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              @page-click="pageClicked"
            ></b-pagination>
          </div>
  
          <div v-if="displayedBlogItems.length === 0" style="height: auto;" class="row m-0 w-100 mb-4">
            <div class="col-12 p-0 d-flex justify-content-center align-items-center empty-blog-message text-center" v-html="blogItems.length === 0 
              ? `There are no blogs available within the last six months` 
              : `There are no blog items available for the blog search: 
                <br>
                &quot${searchQuery}&quot
                `
              ">
            </div>
          </div>

          <div v-if="isRecentBlogs" class="d-flex flex-row justify-content-center mb-5">
            <v-btn
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="goToBlogArchives"
            >
              View Blog Archives
            </v-btn>
          </div>
          <div v-else class="d-flex flex-row justify-content-center mb-5">
            <v-btn
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="gotToRecentBlogs"
            >
              Back To Recent
            </v-btn>
          </div>
        </div>
      </section>
    </div>
  </template>
  <script>
  import debounce from "debounce";
  import { BPagination, BFormInput } from 'bootstrap-vue';
  import BlogPreviewBadge from '../components/library/badges/blog-preview-badge.vue'
  import PageHeader from "./library/widgets/page-header.vue";
  import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
  import TitleTextContent from './library/widgets/title-text-content.vue';
  import SearchControlWidget from './library/widgets/search-control-widget.vue';
  import { EventBus } from '../utils/eventBus';
  export default {
    name: 'blog',
    components: {
      BPagination,
      BFormInput,
      BlogPreviewBadge,
      PageHeader,
      PageHeaderTitleContent,
      TitleTextContent,
      SearchControlWidget,
    },
    props: {
        blogHeaderTitle: String,
        blogItems: Array,
        isRecentBlogs: {
            type: Boolean,
            default: false,
        }
    },
    data() {
      return {
        searchQuery: null,
        currentPage: 1,
        perPage: 10,
        isQueryFromUrl: false,
      };
    },
    computed: {
      blogItemsFromSearchQuery() {
        if (this.searchQuery) {
          return this.blogItems.filter((item) => {
            return this.searchQuery
              .toLowerCase()
              .split(' ')
              .every(
                (v) =>
                  item.title.toLowerCase().includes(v)
              );
          });
        } else {
          return this.blogItems;
        }
      },
      displayedBlogItems() {
        return this.blogItemsFromSearchQuery.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage
        );
      },
      totalRows() {
        return this.blogItemsFromSearchQuery.length;
      },
    },
    mounted: function () {
        const urlDomain = this.isRecentBlogs ? '/#/blog?' : '/#/blogArchives?';
        const urlParams = new URL( window.location.href.replace(urlDomain, '?') );

        const blogPage = urlParams.searchParams.get('blogPage');
        const query = urlParams.searchParams.get('query');

        this.isQueryFromUrl = query != undefined || query != null || query?.trim().length !== '';
        this.currentPage = blogPage ? parseInt(blogPage) : 1;
        EventBus.$emit("update-search-query", query);  
    },
    methods: {
      pageClicked(bvEvent, page) {
        const params = this.searchQuery !== null || this.searchQuery !== "null" || this.searchQuery?.trim() === ""
                        ? 
                          [
                            { param: 'blogPage', value: page }
                          ]
                        : 
                          [
                            { param: 'blogPage', value: page },
                            { param: 'query', value: this.searchQuery }
                          ];
        this.updateUrlQueryParam(
          this.isRecentBlogs ? '#/blog' : '#/blogArchives', 
          params
        );
  
        // window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
          document
            .getElementById("search-query-control")
            .scrollIntoView({ behavior: "smooth", block: "start" });
        }, 500);
      },
      updateSearchQuery(searchText) {
        this.searchQuery = searchText;
      },
      goToBlogArchives(){
        this.$router.push("blogArchives");
      },
      gotToRecentBlogs(){
        this.$router.push("blog");
      },
    },
    watch: {
      searchQuery(newValue) {
        if(!this.isQueryFromUrl) {
            this.currentPage = 1;
        }
  
        debounce(
            () => {
              this.updateUrlQueryParam(
                this.isRecentBlogs ? '#/blog' : '#/blogArchives', 
                [
                  { param: 'blogPage', value: this.currentPage }, 
                  { param: 'query', value: newValue } 
                ]
              );
            }, 
            1000, 
            { immediate: false }
          ).call(this);

        this.isQueryFromUrl = false;
      },
    }
  };
  </script>
  <style scoped>
  #blog-pagination li {
    margin: 0px;
  }
  
  .cover {
    object-fit: cover;
    height: 225px;
    width: 100%;
  }
  
  .breadcrumb-content-skinny {
    min-height: 125px !important;
  }
  
  .breadcrumb-content-skinny h1 {
    margin-bottom: 0 !important;
  }
  
  .empty-blog-message {
    font-family: Rajdhani;
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
    color: #272727;
    word-break: break-all;
  }
  </style>
  